// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4355":"38531559","5968":"dda7d423","8144":"e19e7de0","8890":"e7256b1a"}[chunkId] + ".chunk.css";
};